<div class="grid-x grid-padding-y align-justify top-bar show-for-medium">
  <div class="cell auto">
    <rav-global-search *ngIf="!router.url.includes('/admin')"></rav-global-search>
  </div>
  <div class="cell shrink">
    <rav-account-dropdown></rav-account-dropdown>
  </div>
</div>
<main [ngClass]="router.url.includes('/edit') ? '' : 'content'"><router-outlet></router-outlet></main>
